/**
 * Maps a product name to its corresponding AI underwriting guidance prompt type.
 *
 * @param _carrier - Carrier name (currently unused, kept for API compatibility)
 * @param productName - The insurance product name (e.g., "CareMatters II", "Asset Care")
 * @param isJoint - Whether this is a joint policy
 * @returns The AI prompt type string, or null if product is not supported
 */
export function getAiPromptType(
  _carrier: string,
  productName: string,
  isJoint: boolean,
): string | null {
  const product = productName?.toLowerCase().replace(/[®™©]/g, '').trim() || '';

  if (product.includes('carematters')) {
    return isJoint ? 'underwriting-nw-partner-guidance' : 'underwriting-nw-guidance';
  }

  if (product.includes('asset care')) {
    return isJoint ? 'underwriting-oa-partner-guidance' : 'underwriting-oa-guidance';
  }

  if (product.includes('carescout')) {
    return 'underwriting-cs-guidance';
  }

  if (product.includes('lincoln') || product.includes('moneyguard')) {
    return 'underwriting-lincoln-guidance';
  }

  if (product.includes('securecare')) {
    return 'underwriting-securian-guidance';
  }

  return null;
}
